import audioInit from './audio'

const init = () => {
  if (!process.browser) return
  audioInit()
}

init()
